var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStatisticsIcon = function SvgStatisticsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8125 25.625H27.1875V13.125C27.1875 12.9592 27.1216 12.8003 27.0044 12.6831C26.8872 12.5659 26.7283 12.5 26.5625 12.5H22.1875C22.0217 12.5 21.8628 12.5659 21.7456 12.6831C21.6284 12.8003 21.5625 12.9592 21.5625 13.125V16.25H17.8125C17.6467 16.25 17.4878 16.3159 17.3706 16.4331C17.2534 16.5503 17.1875 16.7092 17.1875 16.875V20H13.4375C13.2717 20 13.1128 20.0659 12.9956 20.1831C12.8784 20.3003 12.8125 20.4592 12.8125 20.625V25.625H12.1875C12.0217 25.625 11.8628 25.6908 11.7456 25.8081C11.6283 25.9253 11.5625 26.0842 11.5625 26.25C11.5625 26.4158 11.6283 26.5747 11.7456 26.6919C11.8628 26.8092 12.0217 26.875 12.1875 26.875H27.8125C27.9783 26.875 28.1372 26.8092 28.2544 26.6919C28.3717 26.5747 28.4375 26.4158 28.4375 26.25C28.4375 26.0842 28.3717 25.9253 28.2544 25.8081C28.1372 25.6908 27.9783 25.625 27.8125 25.625ZM18.4375 17.5H21.5625V25.625H18.4375V17.5ZM14.0625 21.25H17.1875V25.625H14.0625V21.25Z",
    fill: "#664CFF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatisticsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/StatisticsIcon.6653fab9.svg";
export { ForwardRef as ReactComponent };